import React from "react";
import { Modal } from "react-bootstrap";
import NgLoading from "./NgLoading";
import Purchase from "./QuickView/Purchase";
import Sales from "./QuickView/Sales";
import Voucher from "./QuickView/Voucher";
import ShareButton from "./ShareButton";
function QuickView(props) {
  const i = Math.random();
  const ty = props.type || "";
  var sp = ty.split(" ");
  const viewSelect = () => {
    switch (sp[0].toUpperCase()) {
      case "SALES":
        return <Sales id={props.id} type={props.type} />; 
      case "PURCHASE":
        return <Purchase id={props.id} type={props.type} />; 
      case "VOUCHER":
        return <Voucher id={props.id} type={props.type} />;
      case "JOURNAL":
        return <Voucher id={props.id} type={props.type} />;
      case "PAYMENT":
        return <Voucher id={props.id} type={props.type} />;
      case "RECEIPT":
        return <Voucher id={props.id} type={props.type} />;
      default:
        return <NgLoading />;
    }
  };
  return (
    <React.Fragment>
      <Modal
        show={props.trigger}
        className="modal"
        onHide={() => props.hideTrigger(false)}
        key={i}
      >
        <Modal.Dialog>
          <Modal.Body>
            <ShareButton
              title="nullasdas page title"
              PageCss={""}
              id={props.id}
              componentLoad={viewSelect()}
            />
            {viewSelect()}
          </Modal.Body>
        </Modal.Dialog>
      </Modal>
    </React.Fragment>
  );
}
export default React.memo(QuickView);
